import { ITestProvider } from '../../Features/LoadingBar/loadingBarReducer';
import { IRunTriggerFn } from '../../Features/LoadingBar/LoadingBarActionTypes';
import { Environment } from '../Environment';

const cheqResponseResolverNoop = () => {};
let cheqResponseResolver: (requestId: string) => void =
  cheqResponseResolverNoop;

window.onCheqResponse = (_token: string, requestId: string) => {
  cheqResponseResolver(requestId);
};

export const loadCheqScript = () => {
  const scriptElement: HTMLScriptElement = document.createElement('script');
  scriptElement.setAttribute('type', 'text/javascript');
  scriptElement.setAttribute('async', '');
  scriptElement.setAttribute('data-ch', Environment.CHEQ_CHANNEL);
  scriptElement.setAttribute('class', Environment.CHEQ_CLASS);
  scriptElement.setAttribute('data-jsonp', 'onCheqResponse');
  scriptElement.src = Environment.CHEQ_SCRIPT_URL;

  return new Promise<ITestProvider<HTMLScriptElement>>((resolve) => {
    const timeoutId = setTimeout(
      () =>
        resolve({
          status: 'ERROR',
          reason: 'cheq api failed to load; timeout reached',
        }),
      3000,
    );

    scriptElement.addEventListener(
      'load',
      () => {
        resolve({ status: 'LOADED', instance: scriptElement });
        clearTimeout(timeoutId);
      },
      false,
    );
    scriptElement.onerror = (event) => {
      resolve({
        status: 'ERROR',
        reason:
          typeof event === 'string'
            ? `cheq api failed to load; ${event}`
            : 'cheq api failed to load; error encountered while loading script',
      });
      clearTimeout(timeoutId);
    };

    document.head.appendChild(scriptElement);
  });
};

export const waitForCheqToBeReady = () =>
  new Promise<ITestProvider<ICheqInstance>>((resolve) => {
    const timeoutId = setTimeout(() => {
      cheqResponseResolver = cheqResponseResolverNoop;
      resolve({
        status: 'ERROR',
        reason: 'cheq provider did not load; timeout reached',
      });
    }, 3000);

    cheqResponseResolver = (requestId: string) => {
      clearTimeout(timeoutId);
      cheqResponseResolver = cheqResponseResolverNoop;
      resolve({
        status: 'LOADED',
        instance: { requestId },
      });
    };
  });

export const executeCheq =
  (cheq: ICheqInstance): IRunTriggerFn =>
  async () => {
    try {
      const id = cheq.requestId;
      return id
        ? { status: 'LOADED', value: id }
        : { status: 'ERROR', reason: 'cheq execute error; unknown failure' };
    } catch (err) {
      return {
        status: 'ERROR',
        reason:
          err instanceof Error
            ? `cheq execute error; ${err.message}`
            : `cheq execute error; unknown failure`,
      };
    }
  };
